import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";
const Project = ({ project }) => {
  //VARIANTS FOR BUTTON ANIMATION
  const buttonVariantsUp = {
    open: { opacity: 1, y: 0 },
    closed: {
      opacity: 0,
      y: "-100%",
    },
  };
  const buttonVariantsDown = {
    open: { opacity: 1, y: 0 },
    closed: {
      opacity: 0,
      y: "100%",
    },
  };

  //Variant for container
  const fadeIn = {
    show: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, type: "easeIn" },
    },
    hidden: {
      scale: 0.85,
      opacity: 0,
      transition: { duration: 0.5, type: "easeOut" },
    },
  };
  const controls = useAnimation();
  const [element, view] = useInView({ threshold: 0.2 });
  if (view) {
    controls.start("show");
  } else {
    controls.start("hidden");
  }

  //Checking page width to change inline styles
  const [isHovered, setIsHovered] = useState(false);
  const mqList = window.matchMedia("(max-width:630px)");
  const [matches, setMatches] = useState(mqList.matches);
  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mqList.addEventListener("change", handler);
    return () => mqList.removeEventListener("change", handler);
  });
  const styles = {
    flexDirection: matches
      ? "column"
      : project.position === "left"
      ? "row"
      : "row-reverse",
  };
  return (
    <Container
      style={styles}
      variants={fadeIn}
      animate={controls}
      initial="hidden"
      ref={element}
    >
      <div className="image-container">
        <div
          className="hover"
          onMouseEnter={() => setIsHovered((isHovered) => !isHovered)}
          onMouseLeave={() => setIsHovered((isHovered) => !isHovered)}
        >
          <a href={project.live} target="_blank">
            <motion.button
              animate={isHovered ? "open" : "closed"}
              variants={buttonVariantsUp}
              transition={{ type: "spring" }}
            >
              Live Demo
            </motion.button>
          </a>
          <a href={project.repo} target="_blank">
            <motion.button
              animate={isHovered ? "open" : "closed"}
              variants={buttonVariantsDown}
              transition={{ type: "spring" }}
            >
              Repo
            </motion.button>
          </a>
        </div>
        <img src={project.img} alt="" />
      </div>
      <div className="project-description">
        <h3>{project.title} </h3>
        <p>Technologies: {project.technologies}</p>
        <p>{project.description}</p>
      </div>
    </Container>
  );
};

export default Project;

const Container = styled(motion.div)`
  display: flex;
  width: 90%;
  border: 1px solid #2a52be;
  border-radius: 0.4rem;
  min-height: 25rem;
  background-color: #fefefe;
  color: #1f2858;
  margin: 0.5rem 0;
  .image-container {
    flex-basis: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .hover {
      position: absolute;
      z-index: 2;
      width: 90%;
      height: 90%;
      background: none;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.3s ease;
      border-radius: 0.4rem;
      padding: 0.2rem;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px,
        rgba(0, 0, 0, 0.24) 0px 1px 2px;
      a {
        text-decoration: none;
        color: #fefefe;
      }
      button {
        height: 3rem;
        width: 8rem;
        margin: 0rem 0.4rem;
        display: none;
        background: #2a52be;
        color: #fefefe;
        border-radius: 0.4rem;
        cursor: pointer;
        border: none;
        font-size: 1.2rem;

        &:hover {
          background: #1f2858;
        }
      }
      &:hover {
        background: rgba(255, 255, 255, 0.4);
        button {
          display: block;
        }
      }
    }
    img {
      width: 90%;
      height: 90%;
      border-radius: 0.4rem;
    }
  }
  .project-description {
    flex-basis: 50%;
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    flex-direction: column;
    padding: 0 1rem;
  }
  @media only screen and (max-width: 1024px) {
    .image-container {
      flex-basis: 60%;
      .hover {
        height: 80%;
      }
      img {
        height: 80%;
      }
    }
    .project-description {
      flex-basis: 40%;
    }
  }
  @media only screen and (max-width: 630px) {
    .image-container {
      margin: 1rem 0;
      flex-basis: 100%;
      img {
        height: 70%;
        width: 70%;
      }
      .hover {
        width: 70%;
        height: 100%;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .hover {
      flex-direction: column;
      a {
        margin: 0.5rem 0;
      }
    }
  }
`;
